// Aperçu temps réel des écritures qui seront générées (table Débit / Crédit).
// Visible AVANT validation : l'utilisateur voit exactement ce qui sera enregistré.
import React from "react";

const fmt = (n) => (n ? Math.round(n).toLocaleString("fr-FR") : "");

export default function ApercuEcritures({ lignes }) {
  const valides = (lignes || []).filter((l) => (l.debit || 0) > 0 || (l.credit || 0) > 0);
  const totalDebit = valides.reduce((s, l) => s + Math.round(l.debit || 0), 0);
  const totalCredit = valides.reduce((s, l) => s + Math.round(l.credit || 0), 0);
  const equilibre = totalDebit === totalCredit && totalDebit > 0;

  return (
    <div className="rounded-lg border border-[#4A8A8A]/20 overflow-hidden" data-testid="apercu-ecritures">
      <div className="bg-[#2D5A5A] text-white px-3 py-2 text-sm font-semibold">Aperçu des écritures générées</div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-[#4A8A8A] border-b border-[#4A8A8A]/20">
            <th className="py-1.5 px-3">Compte</th>
            <th className="py-1.5 px-3 text-right">Débit</th>
            <th className="py-1.5 px-3 text-right">Crédit</th>
          </tr>
        </thead>
        <tbody>
          {valides.length === 0 ? (
            <tr><td colSpan={3} className="py-3 px-3 text-center text-[#1D3D3D]/50">Complétez le formulaire pour voir l'aperçu.</td></tr>
          ) : valides.map((l, i) => (
            <tr key={i} data-testid={`apercu-ligne-${i}`} className="border-b border-[#4A8A8A]/10">
              <td className="py-1.5 px-3"><span className="font-mono text-xs text-[#4A8A8A]">{l.compte}</span> <span className="text-[#1D3D3D]">{l.libelle}</span></td>
              <td className="py-1.5 px-3 text-right tabular-nums">{fmt(l.debit)}</td>
              <td className="py-1.5 px-3 text-right tabular-nums">{fmt(l.credit)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="font-bold text-[#1D3D3D] border-t-2 border-[#4A8A8A]/30">
            <td className="py-1.5 px-3">TOTAL</td>
            <td data-testid="apercu-total-debit" className="py-1.5 px-3 text-right tabular-nums">{fmt(totalDebit)}</td>
            <td data-testid="apercu-total-credit" className="py-1.5 px-3 text-right tabular-nums">{fmt(totalCredit)}</td>
          </tr>
        </tfoot>
      </table>
      <div data-testid="apercu-equilibre" className={`px-3 py-2 text-xs font-semibold ${equilibre ? "text-emerald-700 bg-emerald-50" : "text-amber-700 bg-amber-50"}`}>
        {equilibre ? "Écriture équilibrée (Débit = Crédit)" : "En attente d'équilibre (Débit = Crédit)"}
      </div>
    </div>
  );
}
